import { Static, Type } from '@sinclair/typebox';
import { TrialSegment, TrialVoie } from '../translation_namespace/trial_relance_namespace';

/**
 * Progression d'un pro en essai — `GET /app/trial-relance/progress`. Source UNIQUE du bandeau
 * « prochaine étape » de l'app : l'app, l'email J1 et le SMS disent la même chose le même jour
 * (plan §6). Recalculée à la demande, jamais persistée ici (le snapshot quotidien est écrit par
 * le cron de relance).
 */
export const TrialNextActionSchema = Type.Object({
  /** Identifiant de la sous-action (`TrialTask.id`), ou `wizard` en mode reprise. */
  id: Type.String(),
  /** Libellé du bandeau (namespace `TRIAL_RELANCE`). */
  label_key: Type.String(),
  cta_key: Type.String(),
  href: Type.String(),
  /** Gain de score si la sous-action est faite (0 pour un jalon ou la reprise du wizard). */
  points: Type.Number(),
  stage: Type.Number(),
});
export type TrialNextActionObject = Static<typeof TrialNextActionSchema>;

export const TrialProgressResponseSchema = Type.Object({
  /** Mode reprise : le wizard n'a pas été quitté et rien n'est personnalisé (plan §1.1). */
  pre_wizard: Type.Boolean(),
  /** Nombre d'étapes du wizard restantes (mode reprise). */
  wizard_steps_left: Type.Number(),
  voie: Type.Union([Type.Enum(TrialVoie), Type.Null()]),
  score: Type.Number(),
  stage_reached: Type.Number(),
  next_stage: Type.Union([Type.Number(), Type.Null()]),
  segment: Type.Enum(TrialSegment),
  /** Jours d'essai restants (calendaires, fuseau du pro), 0 le dernier jour. */
  days_left: Type.Number(),
  next_action: Type.Union([TrialNextActionSchema, Type.Null()]),
});
export type TrialProgressResponseObject = Static<typeof TrialProgressResponseSchema>;
